import axios from "axios";
import config from "./api.config";
import localStorage from './auth-helper'
import router from '../router/index'
import { getHeaders, getHeaderLogin, getFileHeaders, formatRequest, getOrganizationHeaders, getOrganizationHeaderWithToken } from "./api-helpers";

export function getPublicationMetadataDownloadUrl() {
  return config.baseUrl() + "/publications/metadata/download";
}

export function getAll(section) {
    return axios({
        method: "get",
        url: config.baseUrl() + "/" + section + "",
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        return Promise.reject(error);
    });
}
export function getByOrganizationID(section, id) {
    return axios({
        method: "get",
        url: config.baseUrl() + "/" + section + " ",
        headers: getOrganizationHeaders(id)
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        return Promise.reject(error);
    });
}

export function getByID(section, id) {
    return axios({
        method: "get",
        url: config.baseUrl() + "/" + section + "/" + id,
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        return Promise.reject(error);
    });
}
export function getByPagin(section, values) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/" + section + "/paginate",
        data: values,
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        return Promise.reject(error);
    });
}
export function getByPaginById(section,id, values) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/" + section + "/paginate/" + id,
        data: values,
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        return Promise.reject(error);
    });
}
export function postPaginByOrganization(section, values, id) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/" + section + "/paginate",
        data: values,
        headers: getOrganizationHeaders(id)
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        return Promise.reject(error);
    });
}
export function postPaginByOrganizationLTI(section, values, id, token) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/" + section + "/paginate",
        data: values,
        headers: getOrganizationHeaderWithToken(id, token)
    }).catch(error => {
        console.log(error);
        return Promise.reject(error);
    });
}

export function postLTI(section, values, token) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/" + section,
        data: values,
        responseType: "text",
        headers: {
            Accept: "text/html, application/json, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
}

export function getAllLTI(section, token) {
    return axios({
        method: "get",
        url: config.baseUrl() + "/" + section + "",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        },
    });
}
export function update(section, values) {
    return axios({
        method: values.id == 0 ? "post" : "put",
        url: config.baseUrl() + "/" + section,
        data: values,
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        else
            return Promise.reject(error);
    });
}
export function bulUpdate(section, values) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/" + section,
        data: values.bulkData,
        headers: getHeaders()
    }).catch(error => {
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            window.location = '/login';
        }
        else
            return Promise.reject(error.response);
    });
}
export function post(section, values) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/" + section,
        data: values,
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        else
            return Promise.reject(error);
    });
}
export function put(section, values) {
    return axios({
        method: "put",
        url: config.baseUrl() + "/" + section,
        data: values,
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
        else
            return Promise.reject(error);
    });
}

export function DeleteByID(section, id) {
    return axios({
        method: "delete",
        url: config.baseUrl() + "/" + section + "/" + id,
        headers: getHeaders()
    }).catch(error => {
        console.log(error);
        if (error == 'Error: Request failed with status code 401') {
            localStorage.logout();
            //router.push({ name: 'Login' })
            window.location = '/login';
        }
    });
}
export function login(values) {
    return axios({
        method: "post",
        url: config.baseUrl() + "/auth/login",
        data: values,
        headers: getHeaderLogin()
    });
}

export async function updateFile(section, values) {
    console.log('values ' + values)

    const headers = {
        'Content-Type': 'multipart/form-data'
    }
    return axios({
        method: values.id == 0 ? "post" : "put",
        url: config.baseUrl() + "/" + section,
        data: values,
        headers: getHeaders()
    });
}

/*------------LCP Calls----------------------*/

export function UploadToLCP(values) {
    return axios({
        method: "put",
        url: config.lcpUrl() + "/contents/",
        data: values,
        headers: getLcpHeaders()
    });
}

export function downloadFile (section, filename) {
    axios({
          url: config.baseUrl() + "/" + section,
          method: 'GET',
          headers: getHeaders(),
          responseType: 'blob',
      }).then((res) => {
        var blob = res.data;
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
}



export function uploadToGoogleStorage(data, fileName, uuid) {

}




// WEBPACK FOOTER //
// ./src/api/index.js